import { render, staticRenderFns } from "./RegistrationSummary.vue?vue&type=template&id=e436b8d0&scoped=true"
import script from "./RegistrationSummary.vue?vue&type=script&lang=ts"
export * from "./RegistrationSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e436b8d0",
  null
  
)

export default component.exports